export var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};

export var arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

export var asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/focus-lock/dist/es2015/utils/array.js
// module id = ./node_modules/focus-lock/dist/es2015/utils/array.js
// module chunks = conditioner28 conditioner30